import { handleResponse } from './common';
import { convertToFloat } from 'utils/math';

const buildPayload = (props = {}) => {
    const out = {};
    for (const [key, value] of Object.entries(props)) {
        if (value === undefined) continue;
        switch (key) {
            case 'priceCard':
            case 'priceCardBase':
            case 'priceDelivery':
            case 'priceSubtotal':
            case 'priceTotal':
                out[key] = convertToFloat(value);
                break;
            case 'quantityCard':
                out[key] = Number(value) || 1;
                break;
            default:
                out[key] = value;
        }
    }
    return out;
};

export const lineItemsService = {
    addLineItem,
    getLineItem,
    removeLineItem,
    updateLineItemDeliveryPrice,
    updateLineItemTotals,
};

async function addLineItem(lineItem) {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(lineItem)
    };
    return handleResponse(`${process.env.GATSBY_API_URL}/lineitem`, requestOptions)
}
async function updateLineItem(lineItem) {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(lineItem)
    };
    return handleResponse(`${process.env.GATSBY_API_URL}/lineitem`, requestOptions)
}
async function getLineItem(id) {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    };
    return handleResponse(`${process.env.GATSBY_API_URL}/lineitem/${id}`, requestOptions)
}
async function removeLineItem(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'},
    };
    return handleResponse(`${process.env.GATSBY_API_URL}/lineitem/${id}`, requestOptions)
}
async function updateLineItemDeliveryPrice(id, price) {
    const lineItem = await getLineItem(id);

    const requestOptions = {
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            "priceSubtotal": convertToFloat(lineItem.priceTotal + convertToFloat(price)),
            "priceTotal": convertToFloat(lineItem.priceTotal + convertToFloat(price)),
        })
    };
    return handleResponse(`${process.env.GATSBY_API_URL}/lineitem/${id}`, requestOptions)
}

async function updateLineItemTotals(id, { priceCard, priceCardBase, priceDelivery, priceSubtotal, priceTotal, quantityCard }) {
    const body = buildPayload({ priceCard, priceCardBase, priceDelivery, priceSubtotal, priceTotal, quantityCard });
    if (!Object.keys(body).length) return;

    const requestOptions = {
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
    };
    return handleResponse(`${process.env.GATSBY_API_URL}/lineitem/${id}`, requestOptions)
}
